/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 * VxSelect component.
 *
 * This component is used to render a select dropdown with various properties.
 *
 * @example
 * <vx-select options={options}></vx-select>
 */
// eslint-disable-next-line require-jsdoc
export class VxSelect {
    constructor() {
        /**
         * Handles the select change event.
         * Updates the selected state and emits the changed event.
         *
         * @param {Event} event - The select change event.
         */
        this.handleSelect = (event) => {
            const eventTarget = event.target;
            this.selected = eventTarget.value;
            this.changed.emit({ value: eventTarget.value });
        };
        this.options = undefined;
        this.ariaLabel = undefined;
        this.disabled = undefined;
        this.selected = undefined;
    }
    /**
     * @inheritDoc
     */
    render() {
        var _a;
        return (h(Host, { key: '2eca932d2b5502e169e74acd70a05afaf587b534' }, h("select", { key: '721b102177cba63ecdba220bb4fc5ceaba12faf9', part: "select", "aria-label": this.ariaLabel, disabled: this.disabled, onChange: !this.disabled && this.handleSelect }, (_a = this.options) === null || _a === void 0 ? void 0 : _a.map(({ value, id, text }, index) => (h("option", { selected: this.selected === index, value: value, id: id !== null && id !== void 0 ? id : String(index + 1) }, text !== null && text !== void 0 ? text : value))))));
    }
    static get is() { return "vx-select"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-select.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-select.css"]
        };
    }
    static get properties() {
        return {
            "options": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "SelectOptions",
                    "resolved": "ISelectOption[]",
                    "references": {
                        "SelectOptions": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/vx-select/types/index.ts::SelectOptions"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The select options.\nEach option is an object with properties: value, id, text."
                }
            },
            "ariaLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The aria-label attribute of the select."
                },
                "attribute": "aria-label",
                "reflect": true
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables the select if true."
                },
                "attribute": "disabled",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "selected": {}
        };
    }
    static get events() {
        return [{
                "method": "changed",
                "name": "changed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when an option is selected."
                },
                "complexType": {
                    "original": "ISelectedDetail",
                    "resolved": "ISelectedDetail",
                    "references": {
                        "ISelectedDetail": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/vx-select/types/index.ts::ISelectedDetail"
                        }
                    }
                }
            }];
    }
}
//# sourceMappingURL=vx-select.js.map
